import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }



  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/#">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("الصفحة الرئيسية")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("قائمة ادارة الحساب")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/acount-management">{props.t("ادارة الحساب")}</Link>
                </li>
              
              </ul>
            </li>


            <li>
              <Link to="#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("ادارة الخدمات")}</span>
              </Link>
              <ul className="sub-menu">
               
                <li>
                  <Link to="/servicesManagment">{props.t("عرض الخدمات")}</Link>
                </li>
              </ul>
            </li>


            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("ادارة الطلبات")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/service-provider">{props.t("طلبات الانضمام   ")}</Link>
                </li>
                <li>
                  <Link to="/oerder-management">{props.t("طلبات")}</Link>
                </li>
      
              </ul>
            </li>

            <li>
              <Link  to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("إدارة العملاء")}</span>
              </Link>
              <ul className="sub-menu">
               
                <li>
                  <Link to="/clinet-management">{props.t("العملاء")}</Link>
                </li>
              </ul>
            </li>


         
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("  تقرير المستحقات")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/dbinvoices">{props.t(" المستحقات")}</Link>
                </li>
                
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("أرشيف الفواتير")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/transactions_history">{props.t("  الفواتير")}</Link>
                </li>
                <li>
                  <Link to="/deletion_logs">{props.t("سجلات الحذف")}</Link>
                </li>
                <li>
                  <Link to="/refund_request">{props.t("طلبات استرداد")}</Link>
                </li>
                <li>
                  <Link to="/settlement-statements">{props.t("بيانات التسويات")}</Link>
                </li>
                <li>
                  <Link to="/cancellation-tracking">{props.t("تتبع الإلغاءات")}</Link>
                </li>
                
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-share-alt"></i>
                <span>{props.t("إعدادات عامة")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/general-settings">
                   إعدادات
                  </Link>
                </li>
             

              </ul>
            </li>





         

         

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
